import { ITeam } from 'core/models/Models';
import { AppState } from 'core/reducers/RootReducer';
import { createSelector } from 'reselect';

const getStandings = (state: AppState): ITeam[] => state.news.standings;

export const getStandingsSelector = createSelector(getStandings, (news) => news);
